import { Link, useRouterState } from "@tanstack/react-router";
import { counterpartPath, isBanglaPath } from "@/lib/language-switch";

/**
 * Two-segment EN / বাংলা pill. The inactive segment links to the counterpart of
 * the page you're currently on, not to the language home.
 */
export function LanguageSwitcher({
  className = "",
  onNavigate,
}: {
  className?: string;
  onNavigate?: () => void;
}) {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const bn = isBanglaPath(pathname);
  const target = counterpartPath(pathname);

  const base =
    "px-2.5 py-1 rounded-full text-xs leading-none transition whitespace-nowrap";
  const active = `${base} bg-card text-foreground font-semibold`;
  const inactive = `${base} text-muted-foreground hover:text-foreground`;

  return (
    <div
      className={`inline-flex items-center gap-0.5 rounded-full border border-border p-0.5 whitespace-nowrap ${className}`}
      role="group"
      aria-label="Language"
    >
      {bn ? (
        <Link to={target} className={inactive} onClick={onNavigate} hrefLang="en" title="English">
          EN
        </Link>
      ) : (
        <span className={active} aria-current="true">
          EN
        </span>
      )}
      {bn ? (
        <span className={active} aria-current="true" lang="bn">
          বাংলা
        </span>
      ) : (
        <Link
          to={target}
          className={inactive}
          onClick={onNavigate}
          hrefLang="bn"
          lang="bn"
          title="বাংলা"
        >
          বাংলা
        </Link>
      )}
    </div>
  );
}
